import { render, staticRenderFns } from "./SocialFeedConfigurator.vue?vue&type=template&id=6f0c8ce8&"
import script from "./SocialFeedConfigurator.vue?vue&type=script&lang=js&"
export * from "./SocialFeedConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports